import React from 'react';
import ComingSoon from '@/components/shared/ComingSoonSection';
import './BudgetPage.scss';

const BudgetPage = () => {
  return (
    <div className="BudgetPage">
      <ComingSoon title="BudgetPage" />
    </div>
  );
};

export default BudgetPage;